import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

export interface BrandDetailsTitleStyles {
    container?: InjectableCss;
    heading?: TypographyProps;
}

export const titleStyles: BrandDetailsTitleStyles = {
    heading: {
        variant: "h1",
        css: css`
            font-family: "OpenSansBold";
            text-align: center;
            overflow-wrap: break-word;
            word-wrap: break-word;
            margin-top: 0.5em;
        `,
    },
    container: {
        css: css`
            width: 100%;
            margin: 15px;
        `,
    },
};

const styles = titleStyles;

const BrandDetailsTitle: FC<Props> = () => {
    const { value: brand } = useContext(BrandStateContext);
    if (!brand) {
        return null;
    }
    return (
        <StyledWrapper {...styles.container} data-test-selector="brandLogo">
            <Typography data-test-selector="brandLogoHeading" {...styles.heading}>
                {brand.name}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsTitle,
    definition: {
        group: "Brand Details",
        icon: "diamond",
        displayName: "Brand Title",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
